import { helpers, ipAddress, or } from '@vuelidate/validators';

export const CURRENT_TIME_STAMP = 'CURRENT_TIME_STAMP';
export const INVALID_FORMAT_MESSAGE = 'Format incorrect';

// Todo: apply validatorHelpers for old pages
export const validateDate = () =>
    helpers.withMessage(`Value must be 'Date' type`, (value: any) => value instanceof Date);

export const validateAllowBlank = () => helpers.withMessage('', (value: any) => !value);

export const validateDateAfter = (beforeDateField: string = CURRENT_TIME_STAMP) => {
    return helpers.withParams(
        { beforeDateField },
        helpers.withMessage(`Value must be greater than ${beforeDateField}`, (value: Date, vm: any) => {
            const beforeDateValue = beforeDateField == CURRENT_TIME_STAMP ? new Date() : vm?.[beforeDateField];
            return !value || !beforeDateValue || value > beforeDateValue;
        })
    );
};

export const validateFormat = (regex: RegExp, message: string = INVALID_FORMAT_MESSAGE) =>
    // blank or matched regex
    helpers.withMessage(message, (value: string) => !value?.length || regex.test(value));

const IPV6_PATTERN =
    /^(([0-9A-Fa-f]{1,4}:){7}[0-9A-Fa-f]{1,4}|(::ffff:(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9]))|([0-9A-Fa-f]{1,4}:){1,7}:|([0-9A-Fa-f]{1,4}:){1,6}:[0-9A-Fa-f]{1,4})$/;
export const validateIpAddress = () =>
    // ipv4 or ipv6 or ipv6-mapped ipv4
    helpers.withMessage('Invalid ip address', or(ipAddress, validateFormat(IPV6_PATTERN)));

const PASSWORD_RULES = [
    { regex: /^.{8,}$/, message: 'At least 8 characters required' },
    { regex: /[a-z]/, message: 'Must include lowercase letter' },
    { regex: /[A-Z]/, message: 'Must include uppercase letter' },
    { regex: /\d/, message: 'Must include a number' },
    { regex: /[@#$%^&+=!]/, message: 'Must include special character (@#$%^&+=!)' }
] as const;

export const passwordValidators = {
    strongPassword: helpers.withMessage(
        ({ $model: value }) => {
            const failedRule = PASSWORD_RULES.find(rule => !rule.regex.test(value));
            return failedRule?.message || '';
        },
        (value: string) => PASSWORD_RULES.every(rule => rule.regex.test(value))
    )
};

export const strongPassword = helpers.withMessage(
    ({ $model: value }) => {
        const failedRule = PASSWORD_RULES.find(rule => !rule.regex.test(value));
        return failedRule?.message || '';
    },
    (value: string) => PASSWORD_RULES.every(rule => rule.regex.test(value))
);
